export const TOGGLE_AUDIT_HISTORY_MODAL = 'TOGGLE_AUDIT_HISTORY_MODAL'

export const toggleAuditHistoryModal = (show, title, auditHistory) => ({
  type: TOGGLE_AUDIT_HISTORY_MODAL,
  title,
  auditHistory,
  show,
})
